var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_4252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 0H0.5V24H24.5V0ZM15.6123 9.27893C15.9465 9.11276 16.3225 9.11276 16.6149 9.27893L19.9987 11.2315C20.3329 11.4392 20.5 11.7715 20.5 12.1039V16.0504C20.5 16.4243 20.2911 16.7567 19.9987 16.9228L16.6149 18.8754C16.2807 19.0415 15.9047 19.0415 15.6123 18.8754L12.2285 16.9228C11.8943 16.7151 11.7272 16.3828 11.7272 16.0504V14.6795L13.3146 13.7656V15.095C13.3146 15.4688 13.5235 15.8012 13.8159 15.9674L15.6123 17.0059C15.9465 17.1721 16.3225 17.1721 16.6149 17.0059L18.3695 15.9674C18.7037 15.7596 18.8708 15.4273 18.8708 15.095V13.0178C18.8708 12.6439 18.6619 12.3116 18.3695 12.1454L16.5731 11.1068C16.2389 10.9407 15.8629 10.9407 15.5705 11.1068L13.2728 12.4362L11.6854 13.3501L9.38773 14.6795C9.05352 14.8457 8.67755 14.8457 8.38512 14.6795L5.00131 12.727C4.6671 12.5193 4.5 12.1869 4.5 11.8546V7.94955C4.5 7.61721 4.6671 7.28487 5.00131 7.11869L8.42689 5.12463C8.7611 4.95846 9.13708 4.95846 9.4295 5.12463L12.7715 7.07715C13.1057 7.28487 13.2728 7.61721 13.2728 7.94955V9.36202L11.6854 10.276V8.90504C11.6854 8.53116 11.4765 8.19881 11.1841 8.03264L9.38773 6.95252C9.05352 6.78635 8.67755 6.78635 8.38512 6.95252L6.58877 7.9911C6.25457 8.19881 6.08747 8.53116 6.08747 8.8635V10.9407C6.08747 11.3145 6.29634 11.6469 6.58877 11.8131L8.38512 12.8932C8.71932 13.0593 9.0953 13.0593 9.38773 12.8932L11.6854 11.5223L13.2728 10.6499L15.6123 9.27893Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_4252"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.95c89d5a4b31e12263c4b272ebc888c0.svg";
export { ForwardRef as ReactComponent };